import ModernSignIn from './ModernSignIn';

function SignInDefault() {
  return <ModernSignIn />;
}

export default SignInDefault;
